import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoSponsorsGetReq } from "./abst/DtoSponsorsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoSponsorsGetReqImple extends DtoSponsorsGetReq {
  public pager = new DtoApiPager();

  public keyword: string | null = null;

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
